// Constants
import React from 'react';
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import { AppStateContextType } from 'contexts/types/app.contexts.type';

// Components
import { UploadIdSkeletonComponent } from '../components/upload-id/upload-id-skeleton.component';
import { PaymentSkeletonComponent } from '../components/payment/payment-skeleton.component';
import { ContractSkeletonComponent } from '../components/contract/contract-skeleton.component';
import { KycSkeletonComponent } from '../components/kyc/kyc-skeleton.component';
import { OtpSkeletonComponent } from '../components/otp/otp-skeleton.component';
import { ProofOfIncomeSkeletonComponent } from '../components/proof-of-income/proof-of-income-skeleton.component';
import { DefaultSkeletonComponent } from '../components/default/default-skeleton.component';

// eslint-disable-next-line complexity
const getCurrentStateSkeleton = ({ currentState }: { currentState: AppStateContextType }): React.JSX.Element => {
  switch (currentState) {
    case AppStatesEnumeration.CHECKOUT_PENDING:
    case AppStatesEnumeration.CHECKOUT_PENDING_REVIEW:
      return <UploadIdSkeletonComponent />;
    case AppStatesEnumeration.CHECKOUT_DOWNPAYMENT:
      return <PaymentSkeletonComponent />;
    case AppStatesEnumeration.CHECKOUT_IDENTIFICATION:
      return <KycSkeletonComponent />;
    case AppStatesEnumeration.CHECKOUT_INCOME:
      return <ProofOfIncomeSkeletonComponent />;
    case AppStatesEnumeration.CHECKOUT_SIGNING:
    case AppStatesEnumeration.CHECKOUT_SIGNING_CONTRACTUAL:
      return <ContractSkeletonComponent />;
    case AppStatesEnumeration.CHECKOUT_SIGNING_OTP:
      return <OtpSkeletonComponent />;
    default:
      return <DefaultSkeletonComponent />;
  }
};

export { getCurrentStateSkeleton };
